((document, Drupal) => {
  "use strict";
  Drupal.behaviors.header = {
    attach: (context, settings) => {
      // For logged-in users this behaviors is being called multiple times with different context and document context doesn't have child elements.
      if ((settings.user.uid === 0 && context === document) || (settings.user.uid > 0 && typeof (context.classList) !== 'undefined' && context.classList.contains('desktop'))) {
        const headerTopDesktop = document.querySelector('.header.desktop .header__top');
        const headerTopMobile = document.querySelector('.header.mobile .header__top');
        const documentBody = document.querySelector('body');
        const headerMobile = document.querySelector('.header.mobile .header__fixed');

        window.onscroll = function() {myFunction()};

        function myFunction() {
          if (window.pageYOffset >= headerTopDesktop.clientHeight) {
            headerTopDesktop.classList.add("sticky");
          } else {
            headerTopDesktop.classList.remove("sticky");
          }
          if (window.pageYOffset >= headerTopMobile.clientHeight) {
            headerMobile.classList.add("sticky");
          } else {
            headerMobile.classList.remove("sticky");
          }
        }

        // MAM-44 remove dropdown from desktop header
        /*const headerCallButton = document.querySelector('.header.desktop .header__top-actions-call');
        headerCallButton.addEventListener('click', (e) => {
          if (headerCallButton.classList.contains('hidden-drop')) {
            headerCallButton.classList.remove('hidden-drop');
          } else {
            headerCallButton.classList.add('hidden-drop');
          }
        })*/

        const headerPortallButton = document.querySelector('.header.desktop .header__top-actions-portal');
        headerPortallButton.addEventListener('click', (e) => {
          if (headerPortallButton.classList.contains('hidden-drop')) {
            headerPortallButton.classList.remove('hidden-drop');
          } else {
            headerPortallButton.classList.add('hidden-drop');
          }
        })

        const headerSearchButton = document.querySelector('.header.desktop .header__bottom .header__bottom-utility-search button');
        const headerSearchContent = document.querySelector('.header.desktop .header__bottom .header__bottom-utility-search .header__search');
        headerSearchButton.addEventListener('click', (e) => {
          if (headerSearchContent.classList.contains('hidden')) {
            headerSearchContent.classList.remove('hidden');
          } else {
            headerSearchContent.classList.add('hidden');
          }
        })

        var ro = new ResizeObserver(entries => {
          for (let entry of entries) {
            const cr = entry.contentRect;
            if (cr.height >= window.innerHeight) {
              headerMobile.classList.add("tall");
            } else {
              headerMobile.classList.remove("tall");
            }
          }
        });

        ro.observe(headerMobile);

        const phoneFlag = document.getElementById('phone_toggle');
        const searchFlag = document.getElementById('search_toggle');
        const barsFlag = document.getElementById('bottom_toggle');

        const phoneIcon = document.querySelector('.phone-toggle .fa-phone');
        const phoneXmarkIcon = document.querySelector('.phone-toggle .fa-x');

        const searchIcon = document.querySelector('.search-toggle .fa-search');
        const searchXmarkIcon = document.querySelector('.search-toggle .fa-x');

        const barsIcon = document.querySelector('.bottom-toggle .fa-bars');
        const barsXmarkIcon = document.querySelector('.bottom-toggle .fa-x');

        const phoneBottom = document.querySelector('.header.mobile .header__phone');
        const searchBottom = document.querySelector('.header.mobile .header__search');
        const barsBottom = document.querySelector('.header.mobile .header__bottom');

        const quicklinks = document.querySelector('.header.mobile .header__quicklinks');

        function switchIcons(show, hide) {
          show.classList.remove("hidden");
          hide.classList.add("hidden");
        }

        phoneFlag.addEventListener('change', (e) => {
          headerMobile.classList.remove("tall");
          if (e.target.checked) {
            if(searchFlag.checked) {
              switchIcons(searchIcon, searchXmarkIcon);
              searchBottom.classList.add("hidden");
              searchFlag.checked = false;
            }
            if(barsFlag.checked) {
              switchIcons(barsIcon, barsXmarkIcon);
              barsBottom.classList.add("hidden");
              barsFlag.checked = false;
            }
            phoneBottom.classList.remove("hidden");
            quicklinks.classList.add("hidden");
            switchIcons(phoneXmarkIcon, phoneIcon);
          } else {
            phoneBottom.classList.add("hidden");
            quicklinks.classList.remove("hidden");
            switchIcons(phoneIcon, phoneXmarkIcon);
          }
        })

        searchFlag.addEventListener('change', (e) => {
          headerMobile.classList.remove("tall");
          if (e.target.checked) {
            if(phoneFlag.checked) {
              switchIcons(phoneIcon, phoneXmarkIcon);
              phoneBottom.classList.add("hidden");
              phoneFlag.checked = false;
            }
            if(barsFlag.checked) {
              switchIcons(barsIcon, barsXmarkIcon);
              barsBottom.classList.add("hidden");
              barsFlag.checked = false;
            }
            searchBottom.classList.remove("hidden");
            quicklinks.classList.add("hidden");
            switchIcons(searchXmarkIcon, searchIcon);
          } else {
            searchBottom.classList.add("hidden");
            quicklinks.classList.remove("hidden");
            switchIcons(searchIcon, searchXmarkIcon);
          }
        })

        barsFlag.addEventListener('change', (e) => {
          headerMobile.classList.remove("tall");
          if (e.target.checked) {
            if(phoneFlag.checked) {
              switchIcons(phoneIcon, phoneXmarkIcon);
              phoneBottom.classList.add("hidden");
              phoneFlag.checked = false;
            }
            if(searchFlag.checked) {
              switchIcons(searchIcon, searchXmarkIcon);
              searchBottom.classList.add("hidden");
              searchFlag.checked = false;
            }
            barsBottom.classList.remove("hidden");
            documentBody.classList.add("mobile-open");
            quicklinks.classList.add("hidden");
            switchIcons(barsXmarkIcon, barsIcon);
          } else {
            barsBottom.classList.add("hidden");
            documentBody.classList.remove("mobile-open");
            quicklinks.classList.remove("hidden");
            switchIcons(barsIcon, barsXmarkIcon);
          }
        })

        const itemsWithSubmenu = document.querySelectorAll('.header.mobile .header__bottom .menu .menu__item.has-subnav');

        itemsWithSubmenu.forEach(itemWithSubmenu => {
          itemWithSubmenu.addEventListener('click', (e) => {
            if (
              e.target instanceof HTMLAnchorElement &&
              e.target.href &&
              e.target.href[0] !== '#'
            ) {
              return;
            }

            e.preventDefault();
            if (itemWithSubmenu.classList.contains('is-expanded')) {
              itemWithSubmenu.classList.remove('is-expanded');
            } else {
              itemWithSubmenu.classList.add('is-expanded');
            }
          })
        });


      }
    }
  }
})(document, Drupal);
